<template>
  <div>
    <div class="box-wrapper">
      <div class="learn-study-box text-center" v-if="!isDone" id="learn-feedback">
        <div class="pt-11 pb-11 pl-21 pr-21 border-bottom learn-study-header">
          <div class="row">
            <div class="col-md-1 col-2 p-0 d-flex align-items-center" @click="goBack()">
              <i class="fa fa-angle-left" style="color: #c4c4c4; font-size: 32px; cursor: pointer"></i>
            </div>
            <div
              class="col-md-10 col-8 text-center learn-study-title p-0"
              v-translate:dynamic_string="{
                key: `${studyId}_LEARN_FEEDBACK_title`,
                val: lang,
                html: data.title
              }"
            >
              {{ data.title }}
            </div>
            <button data-toggle="modal" v-translate:label_cancel="lang" data-target="#activity_cancel_Modal" style="background-color: transparent; border: none;" class="col-md-1 col-2 text-right pl-0 pr-0 global-cancel-text mt-0 activity-modal-btn">
              Cancel
            </button>
          </div>
        </div>
        <div class="learn-content">
          <p
            class="learn-content-text pl-25 pr-25"
            v-translate:dynamic_string="{
              key: `${studyId}_LEARN_FEEDBACK_summary`,
              val: lang,
              html: data.summary
            }"
          >
            {{ data.summary }}
          </p>
          <form action="" v-if="data.quiz">
            <b-row v-for="(question, index) in questions" :key="index" class="pb-5">
              <b-col cols="12 pb-5">
                <b-col cols="12" v-if="data.quiz[index].type === 'text'">
                  <div
                    class="instruction_title pb-0"
                    v-translate:dynamic_string="{
                      key: `${data.quiz[index].identifier}_body`,
                      val: lang,
                      html: data.quiz[index].body
                    }"
                    v-html="data.quiz[index].body"
                  />
                  <div>
                    <textarea :maxlength="data.quiz[index].limit" @keyup="evt => (question.dirty = evt.target.value === '' ? false : true)" v-model="question.answerText" class="input-text  form-control" v-translate:rsb_hint_step_body_text.placeholder="lang" placeholder="Answer"></textarea>
                    <span class="text-danger pl-5 fw-bold pt-10" v-if="hasFieldError">{{ fieldErrorText }}</span>
                  </div>
                </b-col>
                <b-col cols="12" v-else>
                  <div>
                    <div
                      class="instruction_title"
                      v-html="data.quiz[index].body"
                      v-translate:dynamic_string="{
                        key: `${data.quiz[index].identifier}_body`,
                        val: lang,
                        html: data.quiz[index].body
                      }"
                    />
                    <div v-if="question.dirty" class="selected_value">{{ question.answerText }}</div>
                    <div v-if="data.quiz[index].direction.toLowerCase() === 'horizontal'" class="labels_main">
                      <div class="minimum_label_hr">
                        Min
                      </div>
                      <div class="maximum_label_hr">
                        Max
                      </div>
                    </div>
                    <div v-if="data.quiz[index].direction.toLowerCase() === 'vertical'" class="maximum_label_vr">
                      Max
                    </div>
                    <div @click="question.dirty = true">
                      <ds-slider
                        ref="slider"
                        :piecewise="true"
                        :showMiddleValue="data.quiz[index].middleValue"
                        width="2"
                        :direction="data.quiz[index].direction === 'Vertical' ? 'vertical' : 'horizontal'"
                        tooltip="none"
                        class="vertical-vue-slider pl-0"
                        :disabled="false"
                        @drag-start="question.dirty = true"
                        v-model="question.answerText"
                        :min="data.quiz[index].minValue"
                        :max="data.quiz[index].maxValue"
                        :interval="data.quiz[index].intervals"
                        :data="data.quiz[index].labels ? getTranslatedScaleLabels(data.quiz[index], data.quiz[index].labels) : null"
                        :piecewiseLabel="true"
                        :piecewiseStyle="piecewiseStyle"
                        :piecewiseActiveStyle="piecewiseActiveStyle"
                        :labelActiveStyle="labelActiveStyle"
                      ></ds-slider>
                      <div v-if="data.quiz[index].direction.toLowerCase() === 'vertical'" class="minimum_label_vr">
                        Min
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-col>
            </b-row>
          </form>
          <div class="text-center pt-48">
            <button class="btn btn-submit primary-bg" :disabled="isDisabled" @click="sendFeedback" v-translate:send="lang">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="box-wrapper">
      <div class="learn-study-box text-center" v-if="isDone" id="learnFeedback-c">
        <div class="pt-11 pb-11 pl-21 pr-21 border-bottom">
          <div
            class="text-center learn-study-title"
            v-translate:dynamic_string="{
              key: `${studyId}_LEARN_FEEDBACK_title`,
              val: lang,
              html: feedbackTitle
            }"
          >
            {{ feedbackTitle }}
          </div>
        </div>
        <div class="feedback-content-wrapper">
          <div class="text-center">
            <img src="@/assets/ICN - green check big.png" alt="" class="greencheck-logo" />
            <p class="feedback-title m-0" v-translate:thank_you_for_your_feedback="lang">
              Thank you for your feedback!
            </p>
          </div>
          <div class="text-center pt-40">
            <button class="btn btn-submit" @click="goBack" v-translate:rsb_submit="lang">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="activityCancelModel">
      <div ref="activityCancelModel" class="modal fade" id="activity_cancel_Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg m-10" role="document">
          <div class="modal-content">
            <div class="modal-body modal-padding p-28">
              <div class="verification text-center">
                <label class="email-id p-0 m-0" v-translate:ARE_YOU_SURE_TEXT="lang">Are you sure?</label>
              </div>
              <div class="d-flex justify-content-end pt-50 ml-30 mr-30">
                <div class="col-6 col-md-6 pl-0">
                  <button data-dismiss="modal" class="btn leavestudy" v-translate:label_cancel="lang">
                    Cancel
                  </button>
                </div>
                <div class="col-6 col-md-6 pr-0 discard-btn">
                  <button class="btn leave_study_cntue" data-dismiss="modal" @click="goBack()" v-translate:DISCARD_BUTTON_TITLE="lang">
                    Discard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dsSlider from "@/lib/ds-slider-component";
import Vue from "vue";
import { Widget } from "@/components/services/participant-service";
import { mapGetters } from "vuex";
export default {
  name: "feedback",
  components: {
    dsSlider
  },
  data() {
    return {
      isDone: false,
      widget: new Widget(),
      feedback: "",
      hasFieldError: false,
      questions: this.data.quiz
        ? Vue.util.extend(
            {},
            this.data.quiz.map(item => {
              return {
                answerText: item.type === "text" ? "" : item.minValue,
                dirty: false,
                type: item.type,
                questionId: item.identifier
              };
            })
          )
        : null,
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      }
    };
  },
  props: ["data"],
  computed: {
    ...mapGetters(["participant", "getParticipantsPortalStudyData"]),
    studyId() {
      return this.participant.studyId;
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    feedbackTitle() {
      return this.widget.i18nActivities(`${this.studyId}_LEARN_FEEDBACK_title`, this.lang) ? this.widget.i18nActivities(`${this.studyId}_LEARN_FEEDBACK_title`, this.lang) : this.widget.i18nActivities("FEEDBACK_sectionTitle", this.lang) ? this.widget.i18nActivities("FEEDBACK_sectionTitle", this.lang) : this.data.title;
    },
    isDisabled() {
      return this.data.quiz
        ? this.data.quiz.reduce((result, item, index) => {
            if (result === true) {
              return true;
            } else {
              if (this.questions[index].type === "text" && this.questions[index].answerText === "") {
                return true;
              } else if (this.questions[index].dirty === false) {
                return true;
              }
              return false;
            }
          }, false)
        : true;
    }
  },
  methods: {
    getTranslatedScaleLabels(quiz, labels) {
      const translatedLabels = [];
      if (labels && labels.length) {
        labels.forEach((label, index) => {
          const translation = this.widget.i18nActivities(`${quiz.identifier}_labels_${index}`, this.lang);
          translatedLabels.push(translation || label);
        });
      }
      return translatedLabels;
    },
    scaleValue(question) {
      return question.type === "customScale" ? this.getValueForCustomScale(question) : this.getValueForNumberScale(question);
    },
    getValueForNumberScale(question) {
      if (question.answer || question.answer === 0) {
        return question.answer;
      }
      return question.minValue;
    },
    getValueForCustomScale(question) {
      if (question.answer || question.answer === 0) {
        return question.answer;
      }
      const defaultPointerPosition = question.defaultPointerPosition ? "right" : "left";
      if (defaultPointerPosition == "none" || defaultPointerPosition == "left") {
        return question.labels[0];
      } else if (defaultPointerPosition == "right") {
        return question.labels[question.formattedLabels.length - 1];
      } else if (defaultPointerPosition == "middle") {
        const l = question.labels.length;
        if (l % 2 == 0) {
          const halfLength = l / 2;
          return question.labels[halfLength - 1];
        } else {
          return question.labels[(l - 1) / 2];
        }
      } else {
        return question.labels[0];
      }
    },
    goBack() {
      this.$emit("back", true);
    },
    sendFeedback() {
      const participantLocalTime = new Date().toISOString();
      const qns = [];
      this.data.quiz.forEach((item, index) => {
        const obj = this.questions[index];
        qns.push({
          answerText: obj.answerText,
          appLanguageId: this.participant.languageId,
          displayAnswerText: obj.answerText,
          displayLanguage: this.getParticipantsPortalStudyData.languages[0].language_culture,
          displayQuestionText: item.body,
          questionBody: item.body,
          questionId: item.identifier,
          questionText: item.body,
          questionType: item.type,
          studyVersionId: this.participant.myStudyVersionId
        });
      });
      const data = {
        participantEmail: this.participant.email,
        responses: qns,
        studyId: this.participant.studyId,
        studyName: this.getParticipantsPortalStudyData.name
      };
      this.$api
        .participantProfileLearn(this.participant.pid, participantLocalTime, data)
        .then(() => {
          this.isDone = true;
        })
        .catch(e => {
          const message = this.widget.translate(e.message, "Problem in fetching profile details.");
          this.$toastr.error(message);
        });
    }
  }
};
</script>
<style scoped>
#learn-feedback.learn-study-box,
#learnFeedback-c.learn-study-box {
  height: auto !important;
}
#activity_cancel_Modal .modal-dialog {
  min-width: 440px !important;
}
.learn-study-box {
  width: auto !important;
}
.vue-slider-component.vue-slider-has-label {
  margin-bottom: 48px;
}
.global-cancel-text {
  color: var(--secondary);
}
.learn-study-header {
  background-color: #fff;
}
.learn-study-title,
.learn-study-box .learn-study-title {
  color: #4a4a4a !important;
}
.learn-content-text img {
  max-width: 100% !important;
}
.selected_value {
  margin-bottom: 20px;
}

.labels_main {
  display: flex;
  width: 100%;
}
.minimum_label_hr {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-left: -9px;
  font-size: 12px;
}
.maximum_label_hr {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
}
.maximum_label_vr {
  width: 100%;
  display: flex;
  align-items: flex-start;
  position: relative;
  top: 16px;
  right: 10px;
  font-size: 12px;
}
.minimum_label_vr {
  width: 100%;
  display: flex;
  align-items: flex-start;
  position: relative;
  bottom: 66px;
  right: 10px;
  font-size: 12px;
}
</style>
